import { TerminalSummaryModel } from "../../app/data/terminal-summary/TerminalListModel";
import { BaseState } from "..";

export default interface TerminalSummaryState extends BaseState {
  terminallist: TerminalSummaryModel[],
  loadedAll: boolean,
  error: string,
  requestStarted: boolean;
  fetchPortionStarted: boolean;
  requestCreator: string;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestResponseCode: number;
  requestError: string;
  loading: boolean,
  loadingFailed: boolean,
  loaded: boolean,
  terminalSummaryRequest: {
    page: number,
    last: boolean
  };
}

export const initialTerminalSummaryState: TerminalSummaryState = {
  terminallist: [],
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestResponseCode: 0,
  requestError: "",
  loading: false,
  loadingFailed: false,
  loaded: false,
  loadedAll: false,
  error: "",
  terminalSummaryRequest: {
    page: 0,
    last: false
  },
};
